import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

// A Flight Check batch is a preflight run, keyed by its root run id.
const PREFLIGHT_WORKFLOW_ID = 'preflight';

export function useViewBatch(): (batchId: string) => void {
  const navigate = useNavigate();
  return useCallback(
    (batchId: string) =>
      void navigate({
        to: '/workflows/$workflowId',
        params: { workflowId: PREFLIGHT_WORKFLOW_ID },
        search: { run: batchId },
      }),
    [navigate],
  );
}

/** Opens the preflight workflow with no run, which starts a new batch. */
export function useNewBatch(): () => void {
  const navigate = useNavigate();
  return useCallback(
    () =>
      void navigate({
        to: '/workflows/$workflowId',
        params: { workflowId: PREFLIGHT_WORKFLOW_ID },
      }),
    [navigate],
  );
}
